import React, { useState } from 'react';
import styles from './collapsible-text.module.scss';

interface CollapsibleTextProps {
	text: string[] | string;
	selectedCampaignId?: number;
	conflictCampaignId?: number;
}

export const CollapsibleText: React.FC<CollapsibleTextProps> = ({ text }) => {
	const [isExpanded, setIsExpanded] = useState(false);
	const joinedText = Array.isArray(text) ? text.join(', ') : String(text);
	const shouldTruncate = joinedText.length > 16;

	if (!shouldTruncate) {
		return (
			<div className={styles.textData}>
				<span>{joinedText}</span>
			</div>
		);
	}

	return (
		<div className={styles.textData}>
			<span>{isExpanded ? joinedText : `${joinedText.substring(0, 16)}...`}</span>
			<button onClick={() => setIsExpanded(!isExpanded)} className={styles.showMoreButton}>
				Show {isExpanded ? 'Less' : 'All'}
			</button>
		</div>
	);
};
